import {KecPath, Service, Version, source,noLoginKecApi} from './constants';

//查询未绑定状态网卡列表接口
export const DescribeUnbindNetworkInterfaces = {
    basePath: KecPath,
    params: {
        Action: 'DescribeUnbindNetworkInterfaces',
        Service: 'vpc',
        Version,
        source
    },
    method: 'post'
}

//批量绑定动态网卡
export const AttachNetworkInterfaces = {
    basePath: KecPath,
    params: {
        Action: 'AttachNetworkInterfaces',
        Service,
        Version,
        source
    },
    method: 'post'
}

//批量解绑动态网卡
export const DetachNetworkInterfaces = {
    basePath: KecPath,
    params: {
        Action: 'DetachNetworkInterfaces',
        Version,
        Service,
        source
    },
    method: 'post'
};

export const ValidateIpv6Support = {
    basePath: KecPath,
    params: {
        Action: 'ValidateIpv6Support',
        Service, Version, source
    },
    method: 'get'
}

export const QueryInstanceNetworkInterfaceQuota = {
    basePath: KecPath,
    params: {
        Action: 'QueryInstanceNetworkInterfaceQuota',
        Service, Version, source
    },
    method: 'get'
}

//变更实例类型，获取当前机型可变的机型类型
export const DescribeCanMigrateType = {
    basePath: KecPath,
    params: {
        Action: 'DescribeCanMigrateType',
        Service,
        Version,
        source
    },
    method: 'get'
}

export const QueryNetworkResource = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'QueryNetworkResource',
        Service: 'vpc',
        Version,
        source
    }
};

export const QueryPriceSystem = {
    basePath: KecPath,
    params: {
        Action: 'QueryKvmList',
        Service,
        Version,
        source,
        operateType: 1
    },
    method: 'get'
};
//开启主机
export const StartInstances = {
    basePath: KecPath,
    params: {
        Action: 'StartInstances',
        Service,
        Version,
        source
    },
    method: 'post'
};
//关闭、冷重启主机
export const StopInstances = {
    basePath: KecPath,
    params: {
        Action: 'StopInstances',
        Service,
        Version,
        source
    },
    method: 'post'
};
//重启主机
export const RebootInstances = {
    basePath: KecPath,
    params: {
        Action: 'RebootInstances',
        Service,
        Version,
        source
    },
    method: 'post'
};
//创建镜像
export const CreateImage = {
    basePath: KecPath,
    params: {
        Action: 'CreateImage',
        Service,
        Version,
        source
    },
    method: 'post'
};
//重置密码
export const ModifyInstancePasswd = {
    basePath: KecPath,
    params: {
        Action: 'ModifyInstancePasswd',
        Service,
        Version,
        source
    },
    method: 'post'
};
//敏感操作获取
export const timeLimit = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'getSensetiveOpLimit',
        Service,
        Version,
        source
    },
};
//敏感操作设置
export const timeSet = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'setSensetiveOpLimit',
        Service,
        Version,
        source
    },
};
//发送验证码
export const sendMsg = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'SendSms',
        Service,
        Version,
        source
    },
};
//检验验证码
export const checkSms = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'VerifySms',
        Service,
        Version,
        source
    },
};
//从容灾组删除
export const RemoveAvoid = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'RemoveVmFromDataGuard',
        Service,
        Version,
        source
    },
};
export const judgeGameUser = {
    basePath: '/gameapi/core/api/user/isgameuser/',
    method: 'get'
};

export const OSImageList = {
    basePath: KecPath,
    params: {
        Action: 'ImageConfig',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const getAvoidPackage = {
    basePath: KecPath,
    params: {
        Action: 'QueryDataGuardPackage',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const getAvoidList = {
    basePath: KecPath,
    params: {
        Action: 'DescribeDataGuardGroup',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const createAviod = {
    basePath: KecPath,
    params: {
        Action: 'CreateDataGuardGroup',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const QueryDedicatedHostPackage = {
    basePath: KecPath,
    params: {
        Action: 'QueryDedicatedHostPackage',
        Service,
        Version,
        source,
        operateType: 1,
        ProName: 'EXCLHOST'
    },
    method: 'get'
};

export const DedicateList = {
    basePath: KecPath,
    params: {
        Action: 'DescribeDedicatedHosts',
        Service,
        Version,
        source
    },
    method: 'post'
};


export const QueryEbsPackage = {
    basePath: KecPath,
    params: {
        Action: 'QueryEbsPackage',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const ImageList = {
    basePath: KecPath,
    params: {
        Action: 'DescribeImages',
        Service,
        Version,
        source
    },
    method: 'get'
};
// 获取主机详情
export const GetInstanceByIds = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'GetInstanceByIds',
        Service,
        Version,
        source
    }
};

// 获取主机安全组信息
export const DescribeSecurityGroupList = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeSecurityGroupList',
        Service: 'vpc',
        Version,
        source
    }
};

// 主机列表
export const DescribeInstances = {
    basePath: KecPath,
    params: {
        Action: 'DescribeInstances',
        Service,
        Version,
        source
    }
};
//删除云服务器
export const deleteKec = {
    basePath: KecPath,
    method: 'post',
    params: {
        Action: 'TerminateInstances',
        Service,
        Version,
        source
    }
};

//更改网络配置
export const updateNetworkConfig = {
    basePath: KecPath,
    params: {
        Action: 'ModifyNetworkInterfaceAttribute',
        Service,
        Version,
        source
    },
    method: 'post'
};


export const QueryEipPackage = {
    basePath: KecPath,
    params: {
        Action: 'QueryEipPackage',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const checkBwsConfig = {
    basePath: KecPath,
    params: {
        Action: 'CheckUserConfig',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const bandwidthList = {
    basePath: KecPath,
    params: {
        Action: 'DescribeBandWidthShares',
        Version,
        source
    },
    method: 'get'
};

export const AllVpcInfo = {
    basePath: KecPath,
    params: {
        Action: 'AllVpcInfo',
        Version,
        source,
        Service: 'vpc'
    },
    method: 'get'
};

export const AdrList = {
    basePath: KecPath,
    params: {
        Action: 'DescribeSubnetAvailableAddresses',
        Version,
        source,
        Service: 'vpc'
    },
    method: 'get'
};
export const DescribePrivateIpAddressAttributes = {
    basePath: KecPath,
    params: {
        Action: 'DescribePrivateIpAddressAttributes',
        Version,
        source,
        Service: 'vpc'
    },
    method: 'get'
};
export const AllocatedAdrList = {
    basePath: KecPath,
    params: {
        Action: 'DescribeSubnetAllocatedIpAddresses',
        Version,
        source,
        Service: 'vpc'
    },
    method: 'get'
};
export const DescribeSubnets = {
    basePath: KecPath,
    params: {
        Action: 'DescribeSubnets',
        Service: 'vpc',
        Version,
        source
    },
    method: 'get'
};
export const DescribeInstancePrivateIpQuota = {
    basePath: KecPath,
    params: {
        Action: 'DescribeInstancePrivateIpQuota',
        Service,
        Version,
        source
    },
    method: 'post'
};
//为弹性网卡分配辅助私网ip
export const AssignPrivateIpAddress = {
    basePath: KecPath,
    params: {
        Action: 'AssignPrivateIpAddress',
        Service: 'vpc',
        Version,
        source
    },
    method: 'post'
};
//为弹性网卡删除辅助私网ip
export const UnAssignPrivateIpAddress = {
    basePath: KecPath,
    params: {
        Action: 'UnAssignPrivateIpAddress',
        Service: 'vpc',
        Version,
        source
    },
    method: 'post'
};
export const OtherCardAssociateAddress = {
    basePath: KecPath,
    params: {
        Action: 'OtherCardAssociateAddress',
        Service: 'eip',
        Version,
        source
    },
    method: 'post'
};
export const QueryQuotaDataByName = {
    basePath: KecPath,
    params: {
        Action: 'QueryQuotaDataByName',
        Service,
        Version,
        source
    },
    method: 'post'
};
export const BatchDisassociateAddress = {
    basePath: KecPath,
    params: {
        Action: 'BatchDisassociateAddress',
        Service: 'eip',
        Version,
        source
    },
    method: 'post'
};
export const calcKvmPrice = {
    basePath: KecPath,
    params: {
        Action: 'CalculateKVMPrice',
        Version,
        Service,
        source
    },
    method: 'post'
};
export const calcEipPrice = {
    basePath: KecPath,
    params: {
        Action: 'CalculateEIPPrice',
        Version,
        Service,
        source
    },
    method: 'post'
};

export const calcAvoidPrice = {
    basePath: KecPath,
    params: {
        Action: 'CalculateDataGuardPrice',
        Version,
        Service,
        source
    },
    method: 'post'
};

export const createProduct = {
    basePath: KecPath,
    params: {
        Action: 'CreateProduct',
        Service,
        Version,
        source,
    },
    method: 'post'
};

export const getTagKeysList = {
    basePath: KecPath,
    params: {
        Action: 'DescribeTagKeys',
        Version,
        Service: 'tag',
        // resourceType: 'kec-instance',
        maxResults: 1000,
        source
    },
    method: 'get'
};

export const describeTagValues = {
    basePath: KecPath,
    params: {
        Action: 'DescribeTagValues',
        Version,
        Service: 'tag',
        maxResults: 1000,
        nextToken: '',
        source
    },
    method: 'get'
};

export const getSnapLimitNum = {
    basePath: KecPath,
    params: {
        Action: 'CreateSnapshotInstNum',
        Version,
        Service,
        source
    }
};

// 试用订单余额查询
export const checkTryOrder = {
    basePath: KecPath,
    params: {
        Action: 'QueryTrialKvmList',
        Version,
        Service,
        source
    }
};
//计算试用啥的的价格
export const getRenewPrice = {
    basePath: KecPath,
    params: {
        Action: 'CalculateRenewal',
        Version,
        Service,
        source
    },
    method: 'post'
};
//试用续费
export const tryOrderRenew = {
    basePath: KecPath,
    params: {
        Action: 'TrialProductRenewal',
        Version,
        Service,
        source
    },
    method: 'post'
};
//试用转正
export const tryOrderPositive = {
    basePath: KecPath,
    params: {
        Action: 'TrialToBuy',
        Version,
        Service,
        source
    },
    method: 'post'
};

export const QueryTryBillType = {
    basePath: KecPath,
    params: {
        Action: 'QueryBillTypeByInstanceIds',
        Version,
        Service,
        source
    },
    method: 'post'
};
//购买续费商品
export const RenewalProduct = {
    basePath: KecPath,
    params: {
        Action: 'RenewalProduct',
        Version,
        Service,
        source
    },
    method: 'post'
};
//升配
export const upgradeKvm = {
    basePath: KecPath,
    params: {
        Action: 'updateKVM',
        Version,
        Service,
        source
    },
    method: 'post'
};
//查询通用折扣信息
export const queryCommonDiscount = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'QueryCommonDiscount',
        Service,
        Version,
        source,
    }
};
//查询用户折扣信息
export const queryDisCount = {
    basePath: KecPath,
    params: {
        Action: 'QueryUserSpecialDiscounts',
        Version,
        Service,
        source
    },
    method: 'get'
};
//获取ebs信息
export const queryRenewEbsVolumes = {
    basePath: KecPath,
    params: {
        Action: 'QueryRenewEbsVolumes',
        Version,
        Service,
        source
    },
    method: 'post'
};
//在线升配前检查op状态CheckInstanceOpMetadata
export const checkOp = {
    basePath: KecPath,
    params: {
        Action: 'CheckInstanceOpMetadata',
        Version,
        Service,
        source
    },
    method: 'get'
};
//获取EIP列表
export const getEIPList = {
    basePath: KecPath,
    params: {
        Action: 'DescribeIdleEIPList',
        Version,
        Service: 'eip',
        source
    }
};
//绑定EIP
export const bandEip = {
    basePath: KecPath,
    params: {
        Action: 'AssociateAddress',
        Version,
        Service: 'eip',
        source
    }
};
//解绑eip
export const unBandEip = {
    basePath: KecPath,
    params: {
        Action: 'DisassociateAddress',
        Version,
        Service: 'eip',
        source
    }
};
//添加标签
export const addTags = {
    basePath: KecPath,
    params: {
        Action: 'CreateTags',
        Version,
        Service: 'tag',
        source
    },
    method: 'post'
};

//删除标签
export const deleteTag = {
    basePath: KecPath,
    params: {
        Action: 'DeleteTags',
        Version,
        Service: 'tag',
        source
    },
    method: 'post'
};

export const getProjList = {
    basePath: KecPath,
    params: {
        Action: 'GetAccountProjectList',
        Version: '2015-11-01',
        Service: 'iam',
        source
    },
    method: 'get'
};

export const changeProjTo = {
    basePath: KecPath,
    params: {
        Action: 'UpdateInstanceProjectId',
        Version: '2015-11-01',
        Service: 'iam',
        source
    },
    method: 'post'
};

//更改业务组 获取业务组
export const getGroupIds = {
    basePath: '/console/group/api/getGroupIds',
    params: {},
    method: 'get'
};
export const getBasicGroups = {
    basePath: '/console/group/api/list',
    params: {},
    method: 'get'
};
export const updateGroup = {
    basePath: '/console/group/api/update',
    params: {},
    method: 'put'
};
export const createGroup = {
    basePath: '/console/group/api/save',
    params: {},
    method: 'post'
};
export const updateRelation = {
    basePath: '/console/group/api/updateRelation',
    params: {},
    method: 'put'
};

export const unload = {
    basePath: KecPath,
    params: {
        Action: 'DetachNetworkInterface', // 接口已经废弃
        Version,
        Service,
        source
    },
    method: 'get'
};

export const mount = {
    basePath: KecPath,
    params: {
        Action: 'AttachNetworkInterface',
        Version,
        Service,
        source
    },
    method: 'post'
};

export const batchMountVifs = {
    basePath: KecPath,
    params: {
        Action: 'AttachNetworkInterfaces',
        Version, Service, source
    },
    method: 'post'
}

//降配白名单
export const ValidateDowngrade = {
    basePath: KecPath,
    params: {
        Action: 'ValidateDowngrade',
        Version,
        Service,
        source
    },
    method: 'get'
};
//修改主机名称
export const ModifyInstanceName = {
    basePath: KecPath,
    params: {
        Action: 'ModifyInstanceName',
        Version,
        Service,
        source
    },
    method: 'get'
};
//修改网卡名称
export const ModifyNetworkInterface = {
    basePath: KecPath,
    params: {
        Action: 'ModifyNetworkInterface',
        Version,
        Service: 'vpc',
        source
    },
    method: 'post'
};
//旧版接口，防火墙
export const getFirewallList = {
    basePath: '/console/firewall/v3/initEditAttach',
    params: {},
    method: 'get'
};
//防火墙详情
export const getFireWallDetail = {
    basePath: '/console/firewall/detail/',
    params: {},
    method: 'get'
};
//修改防火墙
export const batchEditAttach = {
    basePath: '/console/firewall/v3/batchEditAttach',
    params: {},
    method: 'post'
};
export const reinstall = {
    basePath: KecPath,
    params: {
        Action: 'ModifyInstanceImage',
        Version,
        Service,
        source
    },
    method: 'post'
};
//创建重装系统商品
export const ModifyImageProduct = {
    basePath: KecPath,
    params: {
        Action: 'ModifyImageProduct',
        Version,
        Service,
        source
    },
    method: 'post'
};
export const RegionInfos = {
    basePath: KecPath,
    params: {
        Action: 'RegionInfos',
        Version,
        Service,
        source
    },
    method: 'get'
};
//修改DNS名称
export const updateDNSName = {
    basePath: KecPath,
    params: {
        Action: 'ModifyDNS',
        Version,
        Service,
        source
    },
    method: 'post'
};
//主机搜索新接口
export const SearchInstances = {
    basePath: KecPath,
    params: {
        // Action: 'SearchInstances',
        Action: 'SearchInstancesExtend',
        Version,
        Service,
        source
    },
    method: 'post'
};
export const DescribeInstancesByTagValue = {
    basePath: KecPath,
    params: {
        Action: 'DescribeInstancesByTagValue',
        Version,
        source,
        Service: 'tag',
        MaxResults: 1000,
        NextToken: ""
    },
    method: 'get'
};
//-预约升配预迁移失败更新状态
export const MigrateUpgradeResetState = {
    basePath: KecPath,
    params: {
        Action: 'MigrateUpgradeResetState',
        Version,
        Service,
        source
    },
    method: 'get'
};
//-恢复绑定和解绑失败状态
export const RecoveryDetachKeyOrAttachKeyState = {
    basePath: KecPath,
    params: {
        Action: 'RecoveryDetachKeyOrAttachKeyState',
        Version,
        Service,
        source
    },
    method: 'get'
};
//-变更实例类型 排队中 可以取消
export const CancelCrossInstanceMigrate = {
    basePath: KecPath,
    params: {
        Action: 'CancelCrossInstanceMigrate',
        Version,
        Service,
        source
    },
    method: 'get'
};

//新价格体系获取套餐价格接口
export const QueryProductGroups = {
    basePath: KecPath,
    params: {
        Action: 'QueryProductGroups',
        Version,
        Service,
        source
    },
    method: 'get'
};

export const Getlines = {
    basePath: KecPath,
    params: {
        Action: 'Getlines',
        Service: 'eip',
        Version,
        source
    },
    method: 'get'
};
//新价格体系--查询单个商品
export const QuerySingleKVM = {
    basePath: KecPath,
    params: {
        Action: 'QueryPriceSystem',
        Version,
        Service,
        source
    },
    method: 'get'
};
//专属虚拟机迁移
export const instanceMigrate = {
    basePath: KecPath,
    params: {
        Action: 'InstanceMigrate',
        Version,
        Service,
        source
    },
    method: 'post'
};
//获取镜像市场镜像
export const describeMarketTAbList = {
    basePath: KecPath,
    params: {
        Action: 'DescribeMarketImageCategories',
        Version,
        Service,
        source
    },
    method: 'get'
}
//获取镜像市场镜像
export const describeMarketImage = {
    basePath: KecPath,
    params: {
        Action: 'DescribeMarketImages',
        Version,
        Service,
        source
    },
    method: 'post'
};

//主机绑定Key接口
export const apiAttachKey = {
    basePath: KecPath,
    params: {
        Action: 'AttachKey',
        Version,
        Service,
        source
    },
    method: 'post'
};

//调整配置 和 变更实例类型 和 公有云主机迁移 都用这个接口
export const ModifyInstanceTypeProduct = {
    basePath: KecPath,
    params: {
        Action: 'ModifyInstanceTypeProduct',
        Version,
        Service,
        source
    },
    method: 'post'
};

//修改显示设置
export const ModifyInstanceScreenResolution = {
    basePath: KecPath,
    params: {
        Action: 'ModifyInstanceScreenResolution',
        Version,
        Service,
        source
    },
    method: 'post'
};

//实例绑定/修改IAM角色）支持批量
export const AttachInstancesIamRole = {
    basePath: KecPath,
    params: {
        Action: 'AttachInstancesIamRole',
        Version: '2016-03-04',
        Service: 'iam',
        source
    },
    method: 'post'
};

//实例解绑IAM角色支持批量
export const DetachInstancesIamRole = {
    basePath: KecPath,
    params: {
        Action: 'DetachInstancesIamRole',
        Version: '2016-03-04',
        Service: 'iam',
        source
    },
    method: 'post'
};

//获取kec服务下所有IAM角色列表
export const DescribeKecIamRoles = {
    basePath: KecPath,
    params: {
        Action: 'DescribeKecIamRoles',
        Version: '2021-04-21',
        Service: 'iam',
        source
    },
    method: 'post'
};

//主机添加容灾组
export const createAvoid = {
    basePath: KecPath,
    params: {
        Action: 'CreateDataGuardProduct',
        Version,
        Service,
        source
    },
    method: 'post'
};

//资源概览接口
export const DescribeOverView = {
    basePath: KecPath,
    params: {
        Action: 'DescribeResourceView',
        Version,
        Service,
        source
    },
    method: 'post'
};

//获取主机可挂载的ebs盘列表
export const DescribeAvailableVolumes = {
    basePath: KecPath,
    params: {
        Action: 'DescribeAvailableVolumes',
        Version,
        Service,
        source
    },
    method: 'post'
};

//获取主机绑定的ebs盘列表
export const DescribeInstanceVolumes = {
    basePath: KecPath,
    params: {
        Action: 'DescribeInstanceVolumes',
        Version,
        Service,
        source
    },
    method: 'get'
};

//主机挂载EBS盘
export const AttachVolume = {
    basePath: KecPath,
    params: {
        Action: 'AttachVolume',
        Version,
        Service,
        source
    },
    method: 'post'
};

//主机卸载EBS盘
export const DetachVolume = {
    basePath: KecPath,
    params: {
        Action: 'DetachVolume',
        Version,
        Service,
        source
    },
    method: 'post'
};

//获取kvm列表
export const queryKvmList = {
    basePath: KecPath,
    params: {
        Action: 'QueryKvmList',
        Service,
        Version,
        source,
    },
    method: 'post'
};

//创建实例启动模板
export const createModel = {
    basePath: KecPath,
    params: {
        Action: 'CreateModel',
        Service,
        Version,
        source
    },
    method: 'post'
};
//创建实例启动模板版本
export const CreateVersion = {
    basePath: KecPath,
    params: {
        Action: 'CreateVersion',
        Service,
        Version,
        source
    },
    method: 'post'
};
//修改实例启动模板
export const modifyModel = {
    basePath: KecPath,
    params: {
        Action: 'CreateModelVersion',
        Service,
        Version,
        source
    },
    method: 'post'
};

//创建预留实例券商品
export const createResProduct = {
    basePath: KecPath,
    params: {
        Action: 'CreateResProduct',
        Service,
        Version,
        source
    },
    method: 'post'
};

// 批量专属虚拟机迁移
export const batchinstanceMigrate = {
    basePath: KecPath,
    params: {
        Action: 'InstanceMigrateBatch',
        Service,
        Version,
        source
    },
    method: 'post'
};
// 定时删除获取服务器时间
export const getTimeddelDate = {
    basePath: KecPath,
    params: {
        Action: 'GetAutoDeleteTime',
        Service,
        Version,
        source
    },
    method: 'post'
};
export const editTimeddelDate = {
    basePath: KecPath,
    params: {
        Action: 'ModifyInstanceAutoDeleteTime',
        Service,
        Version,
        source
    },
    method: 'post'
};

//分配IPV6地址
export const distributeIpv6 = {
    basePath: KecPath,
    params: {
        Action: 'DistributeIpv6',
        Version,
        Service,
        source
    },
    method: 'post'
};

//实例详情页需要获取IPV6 白名单效验
export const distributeIpv6Verification = {
    basePath: KecPath,
    params: {
        Action: 'DistributeIpv6Verification',
        Service,
        Version,
        source
    },
    method: 'post'
};

//获取支持IPV6的机型ProductTypeId的数据
export const getIpv6SupportProductType = {
    basePath: KecPath,
    params: {
        Action: 'GetIpv6SupportProductType',
        Service,
        Version,
        source
    },
    method: 'post'
};

//变更实例类型 白名单效验
export const changeTypeValidWhitelist = {
    basePath: KecPath,
    params: {
        Action: 'ValidWhitelist',
        Service,
        Version,
        source
    },
    method: 'get'
};

//镜像预热 白名单效验
export const preheatingValidWhitelist = {
    basePath: KecPath,
    params: {
        Action: 'ValidWhitelist',
        Service,
        Version,
        source
    },
    method: 'get'
};
//--以下为未登录service--
export const noLoginCalcEipPrice = {
    basePath: noLoginKecApi,
    params: {
        Action: 'CalculateEIPPrice',
        Version,
        Service,
        source
    },
    method: 'post'
};
export const noLoginCalcKvmPrice = {
    basePath: noLoginKecApi,
    params: {
        Action: 'CalculateKVMPrice',
        Version,
        Service,
        source
    },
    method: 'post'
};
export const noLoginQueryNetworkResource = {
    method: 'post',
    basePath: noLoginKecApi,
    params: {
        Action: 'QueryNetworkResource',
        Service: 'vpc',
        Version,
        source
    }
};
export const noLoginCreateProduct = {
    basePath: noLoginKecApi,
    params: {
        Action: 'CreateProduct',
        Service,
        Version,
        source,
    },
    method: 'post'
};
//--以上为未登录service--

//概览页获取产品线动态
export const DescribeUpdateInfos = {
    basePath: KecPath,
    params: {
        Action: 'DescribeUpdateInfos',
        Version,
        Service,
        source
    },
    method: 'post'
};
export const QueryAttachSystemDiskVolume = {
    basePath: KecPath,
    params: {
        Action: 'QueryAttachSystemDiskVolume',
        Version,
        Service,
        source
    },
    method: 'post'
};
export const AttachSystemDiskVolume = {
    basePath: KecPath,
    params: {
        Action: 'AttachSystemDiskVolume',
        Version,
        Service,
        source
    },
    method: 'post'
};
//创建预迁移
export const PreMigrateInstance = {
    basePath: KecPath,
    params: {
        Action: 'PreMigrateInstance',
        Version,
        Service,
        source
    },
    method: 'post'
};
//取消创建预迁移
export const CancelPreMigrateInstance = {
    basePath: KecPath,
    params: {
        Action: 'CancelPreMigrateInstance',
        Version,
        Service,
        source
    },
    method: 'post'
};
//获取剩余可开小套餐数量
export const DescribeMinFlavorCount = {
    basePath: KecPath,
    params: {
        Action: 'DescribeMinFlavorCount',
        Version,
        Service,
        source
    },
    method: 'get'
};

//获取项目制最大可查询数量
export const DescribeProjectMaxNum = {
    basePath: KecPath,
    params: {
        Action: 'DescribeProjectMaxNum',
        Service,
        Version,
        source
    },
    method: 'get'
};
//创建定时预迁移
export const ModifyInstanceAutoPreMigrateTime = {
    basePath: KecPath,
    params: {
        Action: 'ModifyInstanceAutoPreMigrateTime',
        Version,
        Service,
        source
    },
    method: 'post'
};
//取消定时预迁移
export const CancelInstanceAutoPreMigrateTime = {
    basePath: KecPath,
    params: {
        Action: 'CancelInstanceAutoPreMigrateTime',
        Version,
        Service,
        source
    },
    method: 'post'
};

//获取实例系统盘信息
export const DescribeInstanceSystemVolume = {
    basePath: KecPath,
    params: {
        Action: 'DescribeInstanceSystemVolume',
        Version,
        Service,
        source
    },
    method: 'post'
};
//获取某个VPC下所有的安全组
export const SecurityGroupVpcInfo = {
    basePath: KecPath,
    params: {
        Action: 'SecurityGroupVpcInfo',
        Version,
        Service:'vpc',
        source
    },
    method: 'post'
};
//获取可绑定的安全组最大值
export const DescribeSecurityGroupsQuota = {
    basePath: KecPath,
    params: {
        Action: 'DescribeSecurityGroupsQuota',
        Version,
        Service,
        source
    },
    method: 'post'
};

// 设置资源保护开关
export const SetInstanceResourceProtect = {
    basePath: KecPath,
    params: {
        Action: 'SetInstanceResourceProtect',
        Version,
        Service,
        source
    },
    method: 'post'
};

//创建预迁移
export const QueryProductNetworkInterfaceQuota = {
    basePath: KecPath,
    params: {
        Action: 'QueryProductNetworkInterfaceQuota',
        Version,
        Service,
        source
    },
    method: 'get'
};

// 用户已经开通机型
export const DescribeCreateVmType = {
    basePath: KecPath,
    params: {
        Action: 'DescribeCreateVmType',
        Version,
        Service,
        source
    },
    method: 'post'
};

// 获取ebs盘的吞吐量和IOPS
export const DescribeEbsPerfQuotas = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeEbsPerfQuotas',
        Service,
        Version,
        source
    }
};

export const DescribeDedicatedBlockStorageClusters = {
    basePath: KecPath,
    params: {
        Action: 'DescribeDedicatedBlockStorageClusters',
        Version,
        Service,
        source
    },
    method: 'post'
};


// 查询用户计费类型
export const DescribeVmUserBillType = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'DescribeVmUserBillType',
        Service,
        Version,
        source
    }
};

// 查看待生效的更改计费类型任务
export const DescribeBatchBillTypeChangeTasks = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeBatchBillTypeChangeTasks',
        Service,
        Version,
        source
    }
};

// 查看待生效的更改计费类型任务
export const BatchUpgradeInstanceChargeType = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'BatchUpgradeInstanceChargeType',
        Service,
        Version,
        source
    }
};

// 批量请求价格
export const BatchUpgradeCalculateKVMPrice = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'BatchUpgradeCalculateKVMPrice',
        Service,
        Version,
        source
    }
};

// 批量请求价格
export const DescribeSystemDiskSizeRange = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeSystemDiskSizeRange',
        Service,
        Version,
        source
    }
};
//获取主机可挂载的ebs盘列表, 新接口，支持分页和搜索查询
export const DescribeAvailableVolumesV2 = {
    basePath: KecPath,
    params: {
        Action: 'DescribeAvailableVolumesV2',
        Version,
        Service,
        source
    },
    method: 'post'
};
export const DescribeMultiAttachInstanceType = {
    basePath: KecPath,
    params: {
        Action: 'DescribeMultiAttachInstanceType',
        Version,
        Service,
        source
    },
    method: 'post'
};
// 定时转正
export const ScheduleTrialToBuy = {
    basePath: KecPath,
    params: {
        Action: 'ScheduleTrialToBuy',
        Version,
        Service,
        source
    },
    method: 'post'
};
// 取消定时转正
export const CancelScheduleTrialToBuy = {
    basePath: KecPath,
    params: {
        Action: 'CancelScheduleTrialToBuy',
        Version,
        Service,
        source
    },
    method: 'post'
};
// 查询定时转正
export const QueryScheduleTrialToBuy = {
    basePath: KecPath,
    params: {
        Action: 'QueryScheduleTrialToBuy',
        Version,
        Service,
        source
    },
    method: 'post'
};